// ** React Imports
import React, { useState } from 'react'

// ** Vertical Menu Items Array
import { useVerticalLayout } from '@navigation/vertical'

// ** Vertical Menu Components
import VerticalMenuHeader from '../new-vertical-menu/VerticalMenuHeader'
import VerticalNavMenuItems from '../new-vertical-menu/VerticalNavMenuItems'
import { useSelector } from 'react-redux'
import ContributorModal from '../../../../../views/_templates/ContributorModal'
import ArcRequestModal from '../../../../../views/_templates/ArcRequestModal'
import { Role } from '../../../../../utility/types'
import UserCard from './UserCard'
import SearchModal from '../../../../../navigation/vertical/SearchModal'

const Sidebar = (props) => {
  const notificationBar = document.getElementById('schedule-notification')
  const isBannerVisible = useSelector(
    (state) => state.notificationContextReducer.scheduleNotificationContext?.isBannerVisible
  )

  const getCustomizerStyle = (notificationBar) => {
    if (notificationBar && isBannerVisible) {
      const barHeight = notificationBar ? getComputedStyle(notificationBar).height : '0px'
      return {
        zIndex: 3,
        position: 'fixed',
        height: `calc(100% - ${barHeight} - 10px)`, // subtract 10px to prevent sidebar overflow
        ...(isBannerVisible && { marginBottom: barHeight })
      }
    } else {
      return {
        zIndex: 3
      }
    }
  }

  const { roles } = useSelector((state) => state.userContextReducer.userContext)
  const isContributor = roles?.includes(Role.Contributor)

  // ** Props
  const {
    menuCollapsed,
    routerProps,
    menu,
    currentActiveItem,
    skin,
    isFocusMode,
    isSidebarVisible
  } = props
  const { newVerticalNavItem, isSearchModalOpen, setIsSearchModalOpen } = useVerticalLayout()

  // ** States
  const [groupOpen, setGroupOpen] = useState([])
  const [groupActive, setGroupActive] = useState([])
  const [activeItem, setActiveItem] = useState(null)
  const [contributorModal, setContributorModal] = useState(false)
  const [isArcRequestModalOpen, setIsArcRequestModalOpen] = useState(false)

  const handleToggleArcRequestModal = () => {
    setIsArcRequestModalOpen((prevState) => !prevState)
    setContributorModal((prevState) => !prevState)
  }

  return (
    <div
      className={`main-menu menu-shadow !fixed theme-sidebar-surface ${
        menuCollapsed === false ? 'expanded' : ''
      } ${skin !== 'semi-dark' && skin !== 'dark' ? 'menu-light' : ''} ${
        skin === 'semi-dark' || skin === 'dark' ? 'menu-dark' : ''
      }`}
      style={getCustomizerStyle(notificationBar)}>
      {menu ? (
        menu(props)
      ) : (
        <>
          {/* Vertical Menu Header */}
          <VerticalMenuHeader setGroupOpen={setGroupOpen} {...props} />
          {(!isFocusMode || (isFocusMode && isSidebarVisible)) && (
            <ul
              className={`navigation navigation-main d-flex flex-column overflow-y-auto justify-content-start align-items-stretch dynamic-nav-height`}>
              <VerticalNavMenuItems
                items={newVerticalNavItem}
                groupActive={groupActive}
                setGroupActive={setGroupActive}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
                groupOpen={groupOpen}
                setGroupOpen={setGroupOpen}
                routerProps={routerProps}
                menuCollapsed={menuCollapsed}
                menuHover={false}
                currentActiveItem={currentActiveItem}
              />
            </ul>
          )}
        </>
      )}
      <UserCard menuCollapsed={menuCollapsed} />
      {contributorModal && (
        <ContributorModal
          isOpen={contributorModal}
          toggle={() => setContributorModal(!contributorModal)}
          handleToggleArcRequestModal={handleToggleArcRequestModal}
          isContributor={isContributor}
        />
      )}
      {isArcRequestModalOpen && (
        <ArcRequestModal
          isOpen={isArcRequestModalOpen}
          toggle={() => setIsArcRequestModalOpen(false)}
          isContributorReq={true}
        />
      )}
      {isSearchModalOpen && (
        <SearchModal
          isOpen={isSearchModalOpen}
          toggle={() => setIsSearchModalOpen(!isSearchModalOpen)}
        />
      )}
    </div>
  )
}

export default Sidebar
